import { render } from "./Laboratorio.vue?vue&type=template&id=11c8ecad&scoped=true"
import script from "./Laboratorio.vue?vue&type=script&lang=js"
export * from "./Laboratorio.vue?vue&type=script&lang=js"

import "./Laboratorio.vue?vue&type=style&index=0&id=11c8ecad&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\rotcen_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11c8ecad"]])

export default __exports__